import {Injectable} from "@angular/core";
import {FilterDataService} from "./filter-data.service";

@Injectable()
export class ShowConditionV2Service {

  constructor(
    private filterDataService: FilterDataService
  ) {
  }

  // value : send this.value
  // schema : send schema show condition
  // paramCondition : params condition (or / and)
  checkShowCondition(value: any, schema: any, paramCondition: any) {
    let showTemp: boolean = true;
    if (value && schema) {
      if (schema && schema) {
        if (schema) {
          let showCondition = schema;
          if (showCondition.length > 0) {
            showTemp = (paramCondition == 'or') ? false : true;
            let beforeCondition: boolean = false;
            showCondition.forEach(element => {
              if (paramCondition == 'or') {
                for  (let key in value) {
                  if (element.hasOwnProperty('paramCondition')) {
                    if (element.paramCondition == 'eq') {
                      if (element.paramKey == key) {
                        beforeCondition = (element.paramValue == value[key]) ? true : false;
                        const cek = (element.paramValue == value) ? true : false;
                        if (beforeCondition) {
                          showTemp = true
                        }
                        if (cek) {
                          return showTemp = true;
                        }
                      }
                    } else if (element.paramCondition == 'neq') {
                      if (element.paramKey == key) {
                        beforeCondition = (element.paramValue != value[key]) ? true : false;
                        if (beforeCondition) {
                          showTemp = true
                        }
                      }
                    } else if (element.paramCondition == 'not' && element.paramValue == 'notNull') {
                      const filter = this.filterDataService.filter(element.paramKey, value);
                      if (filter) {
                        showTemp = true
                      }
                    }
                  } else {
                    if (element.paramKey == key) {
                      beforeCondition = (element.paramValue == value[key]) ? true : false;
                      if (beforeCondition) {
                        showTemp = true
                      }
                    }
                  }
                }
              } else if (paramCondition == 'and') {
                if (showTemp) {
                  for (let key in value) {
                    if (element.hasOwnProperty('paramCondition')) {
                      if (element.paramCondition == 'eq') {
                        if (element.paramKey == key) {
                          showTemp = (element.paramValue == value[key]) ? true : false;
                        }
                      } else if (element.paramCondition == 'neq') {
                        if (element.paramKey == key) {
                          showTemp = (element.paramValue != value[key]) ? true : false;
                        }
                      }
                    } 
                    
                    else {
                      if (element.paramKey == key) {
                        showTemp = (element.paramValue == value[key]) ? true : false;
                      }
                    }
                  }
                }
              }
            });
          }
        }
      }
    }
    return showTemp;
  }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/helper/show-condition-v2.service.ts